// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "FigmaEmbed-module--bx--text-truncate--end--nR467";
export var bxTextTruncateFront = "FigmaEmbed-module--bx--text-truncate--front--RH4tw";
export var text = "FigmaEmbed-module--text--AcFD0";
export var wrapper = "FigmaEmbed-module--wrapper--oZr7t";